// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XPjH","col":"styles_col__3NLjb"};